import { Card, CardContent, CardMedia, IconButton, Typography, Box } from '@mui/material'
import { Close } from '@mui/icons-material'
import { DisplayCurrency, CartActionsButton } from 'components'
import PriceDisplay from './PriceDisplay'

const CartView = ({
  product,
  finalPrice,
  getQuantity,
  handleAdd,
  handleRemove,
  removeWholeProductFromCart,
  itemIds,
}) => (
  <Card sx={{ display: 'flex', height: 'auto', minHeight: 140, mb: 3, position: 'relative' }}>
    <CardMedia component="img" sx={{ width: 140, height: 140, objectFit: 'cover' }} image={product.thumbnail} alt={product.title} />
    <CardContent sx={{ flex: '1 0 auto' }}>
      <Typography variant="h6">{product.title}</Typography>
      {product.variantCombination && (
        <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.5 }}>
          {Object.entries(product.variantCombination).map(([key, value]) => 
            `${key}: ${value}`
          ).join(', ')}
        </Typography>
      )}
      <PriceDisplay product={product} finalPrice={finalPrice} />
      <CartActionsButton
        inCart={itemIds.includes(product._id)}
        layoutStyle="compact-icon-buttons"
        stock={product.stock}
        quantity={getQuantity(product._id, product.variantId)}
        onAdd={handleAdd}
        onRemove={handleRemove}
      />
      <Typography sx={{ mb: 3 }} variant="overline">
        <DisplayCurrency number={finalPrice} /> x {getQuantity(product._id, product.variantId)} ={' '}
        <DisplayCurrency number={finalPrice * getQuantity(product._id, product.variantId)} />
      </Typography>
    </CardContent>
    <IconButton
      size="small"
      sx={{ position: 'absolute', top: 0, right: 0 }}
      onClick={() => removeWholeProductFromCart(product.itemId)}
    >
      <Close />
    </IconButton>
  </Card>
)

export default CartView
